const PASSWORD_REGEX: RegExp = /^(?=.*[0-9a-zA-Z]).{6,}$/;

const CLEAN_STRINGS: RegExp = /^([^@&£$€‰¶()^=%!?#]*)$/i;

const CLEAN_ALPHA_STRINGS: RegExp = /^([^@&£$€‰¶()^=%!?#]*)$/i;

// eslint-disable-next-line no-useless-escape
const EMAIL_REGEX: RegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// From: https://regexr.com/39nr7
const URL_REGEX: RegExp =
  // eslint-disable-next-line no-useless-escape
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

// https://www.geeksforgeeks.org/how-to-validate-hexadecimal-color-code-using-regular-expression/
const HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{6})$/;

const QUICK_ACCESS_CODE_REGEX: RegExp = /^[0-9]{4}$/;

export {
  CLEAN_ALPHA_STRINGS,
  CLEAN_STRINGS,
  EMAIL_REGEX,
  HEX_COLOR_REGEX,
  PASSWORD_REGEX,
  URL_REGEX,
  QUICK_ACCESS_CODE_REGEX,
};
